import {Pipe, PipeTransform} from '@angular/core';
import {PrecisionByNumberPipe} from "./precision-by-number.pipe";

@Pipe({
  name: 'digitInfoByNumber'
})
export class DigitInfoByNumberPipe implements PipeTransform {

  constructor(private precisionByNumberPipe: PrecisionByNumberPipe) {
  }

  transform(value?: number): string {
    let number = this.precisionByNumberPipe.transform(value)

    // 1000 | 3 -> 3
    // 1 | 0 -> 6
    // 1000000 | 6 -> 0

    number = number+1;

    switch (number) {
      case 0:
        return '1.6-6';
      case 1:
        return '1.5-5';
      case 2:
        return '1.4-4';
      case 3:
        return '1.3-3';
      case 4:
        return '1.2-2';
      case 5:
        return '1.1-1';
      case 6:
        return '1.0-0';
    }
  }
}

